	import React, { Fragment } from 'react';
	import ReactDOM from 'react-dom';
	import LoggedInPage from '../../views/core/LoggedInPage';
	import Iframe from 'react-iframe';
	import $ from 'jquery';
	import '../../css/GetTest.css';
	import HmAjax from '../../util/HmAjax';
	import Pagination from 'react-ultimate-pagination-material-ui';
	import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
	import { confirmAlert } from 'react-confirm-alert'; // Import
	import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

	// import CircularProgressbar from 'react-circular-progressbar';
	import 'react-circular-progressbar/dist/styles.css';
	import HmEventRegistry from '../../model/HmEventRegistry';



	class ContestGetTest extends LoggedInPage {

	constructor(props) {
		super(props);
		this.displayTextObj = {};
		this.displayTextObj.solutionTitle = this.rb("editor.solutionTitle");
		this.displayTextObj.answerTitleSingle = "";
		this.displayTextObj.answerTitlePlural = "";
		this.displayTextObj.showEditorTooltip = this.rb("editor.showEditorTooltip");
		this.displayTextObj.hideEditorTooltip = this.rb("editor.hideEditorTooltip");
		this.displayTextObj.enterAnswerMessage = this.rb("editor.enterAnswerMessage");

	//var iframeContentUrl = this.getUrlFor("IFRAME_DOMAIN") + "/prassoapp/20171102/";
	//console.log(this.props.topicInfoObj);
	//console.log("currentQNo="+this.props.topicInfoObj.userTest.currentQNo);
	this.testCompleted = false;
	this.showSolution = false;

	this.currentQuestionNo=(!isNaN(props.topicInfoObj.currentQNo) && props.topicInfoObj.currentQNo > 0 && (props.topicInfoObj.currentQNo <= props.topicInfoObj.questionCount)) ? (props.topicInfoObj.currentQNo) : 1;

	this.state = {
		pageCurrent: (this.props.topicInfoObj.testMode==1) ? this.currentQuestionNo : this.props.topicInfoObj.currentAttempt,
		currentAttempt: (this.props.topicInfoObj.testMode==1) ? this.currentQuestionNo : this.props.topicInfoObj.currentAttempt ,
		/*currentQuesNo:(this.props.topicInfoObj.testMode==1) ? 1 : this.props.topicInfoObj.currentQNo,*/
		currentQuesNo: this.currentQuestionNo,
		pageTotal: this.props.topicInfoObj.questionCount,
		totalQuestions:this.props.topicInfoObj.questionCount,
		paginationDisabled:false,
		percentageComplete:0,
		testMode:this.props.topicInfoObj.testMode,
		questionObj:[],
		questionRendered:false,
		attemptedQuestions:this.props.topicInfoObj.attempts || new Object(),
		questionEvaluated:false,
		showSolution:this.showSolution,
		testCompleted:this.testCompleted
	};

	this.onPageChange = this.onPageChange.bind(this);

	this.handleMessage = this.handleMessage.bind(this);
	this.iframeLoaded = this.iframeLoaded.bind(this);
	this.getQuestion = this.getQuestion.bind(this);
	this.modalCloseEvent = this.modalCloseEvent.bind(this);
	this.submitClick = this.submitClick.bind(this);
	this.EvaluateClick = this.EvaluateClick.bind(this);
	this.NextClick = this.NextClick.bind(this);
	this.PrevClick = this.PrevClick.bind(this);
	this.SaveClick = this.SaveClick.bind(this);
	this.viewHideSolutionClick = this.viewHideSolutionClick.bind(this);
	this.submitPractice = this.submitPractice.bind(this);
	this.enableQuestionTrackTimer = false;
	this.intervalId = null;
	this.checkImageLoaded = this.checkImageLoaded.bind(this);
	this.trackTestClose = this.trackTestClose.bind(this);

	//this.markAttemptedQuestions = this.markAttemptedQuestions.bind(this);

	this.forceSubmit = false;
	this.attemptBeforeEvaluate = null;

	this.prassoView = null;
	this.isPrassoViewLoaded = false;
	this.evalAndNavigate = false;
	this.evalAndSubmit = false;
	this.isSubmitTriggered = false;
	this.submittedQnMap = new Object();

	this.correctAns = false;
	this.solutionResults = [];
	this.attemptsLeft;
	this.allowedAttempts;
	this.currentAttempt;

	this.seenQnCount = 0;
	this.completedQuestionCnt;
	this.totalNoQuestions=0;

	this.isEvaluationGoing = false;
	this.currTestQuestionId = null;
	this.currentSnippetId = null;
	this.questionAnswerStartTime = null;
	this.questionAnswerElapsedTime = null;
	this.timeSpentAction="";
	this.currentRating = null;
	this.allQuestions= [];

	this.iframeContentDomain = null;//"http://local.retailmath.com:3000/";
	//const UltimatePagination = reactUltimatePaginationBasic.default;  	

	this.trackingQuestionObj = {};
	this.questionLoadTime = null;
	this.questionStart = 1;
	this.nextQuestionNo = 0;

	//This var is responsible for 
	//this.attemptedQuestionIndices = new Set();

	this.canMoveToNextQuestion = false;
	}

	/*
	* IMPORTANT: This is for the very last question attempted by the user.
	* Auto-submission will still work from TimerComp irrespective of the configuration window.auto_submit_types - FOR NOW
	*/
	isAutoSubmitAllowed(){
		try{
			let testType = this.props.topicInfoObj.testType;

			if(window.auto_submit_types && window.auto_submit_types.length > 0){
				return (~window.auto_submit_types.indexOf(testType)) ? true:false;
			}
		}catch(e){
			console.error(e);
		}

		return false;
	}

	setTmpQuestionNo(tmpQuestionNo){
		this.tmpQuestionNo = (!isNaN(tmpQuestionNo) && tmpQuestionNo > 0 && tmpQuestionNo <= this.getTotalQuestions()) ? tmpQuestionNo: this.currentQuestionNo;
	}

	getTmpQuestionNo(){
		return this.tmpQuestionNo;
	}

	getCurrentQuestionNo(){
		return this.currentQuestionNo;
	}

	getTotalQuestions(){
		return this.totalNoQuestions;
	}

	forceSubmitMode(testMode){
		if(!isNaN(testMode) && window.force_submit_test_mode){
			return ~window.force_submit_test_mode.indexOf(testMode) ? true: false;
		}

		return false;
	}

	onCloseHandler(){
		if(!this.isAjaxSubmitTriggered && (this.forceSubmitMode(this.state.testMode) || this.isAutoSubmitAllowed()) && this.getCurrentQuestionNo() > this.getTotalQuestions()){	
			this.completeTest();
		}else{
			//this.triggerGetUserAnswer();
			console.warn("This test is not eligible for submit on close.");
		}
	}

	prevchangeEvent(page){
	//this.getQuestion();
	this.timeSpentAction = "Pagination";
	this.evalAndNavigate = true;
	this.evalAndSubmit = false;

	let currClickQues = page || this.getCurrentQuestionNo();
	if(!page){
		page = currClickQues - 1;		
	 }	 
	 this.setTmpQuestionNo(page);
	 this.setState({pageCurrent:page, paginationDisabled:true});

	this.nextQuestionNo = page;

	this.evalAns();
	// const me = this;
	// 	setTimeout(() => {
	// 		me.markAttemptedQuestions();
	// 	}, 1500); 
	}
	changeEvent(page){
	//this.getQuestion();
	this.timeSpentAction = "Pagination";
	this.evalAndNavigate = true;
	this.evalAndSubmit = false;

	let currClickQues = page || this.getCurrentQuestionNo();
	if(!page){
		page = currClickQues + 1;		
	 }	 
	 this.setTmpQuestionNo(page);
	 this.setState({pageCurrent:page, paginationDisabled:true});

	this.nextQuestionNo = page;

	this.evalAns();
	// const me = this;
	// 	setTimeout(() => {
	// 		me.markAttemptedQuestions();
	// 	}, 1500); 
	}

	onPageChange(page) {  
		if(this.canMoveToNextQuestion){
			this.changeEvent(page);	
		}else{
			console.warn("cannot move to a differeng question until current one is rendered.");
		}		 	
	} 

	evalAns(){
	this.showSolution = false;
	this.correctAns = false;
	this.solutionResults = undefined;
	this.setState({showSolution:false});
	this.prassoView.postMessage({name:"getUserAnswer"}, this.iframeContentDomain);
	}
	iframeLoaded(){	   
	if(!this.container){
		this.container = document.getElementById("quesIframe");
	}

	const iframeDOMNode = ReactDOM.findDOMNode(this.container)
	this.prassoView = iframeDOMNode.contentWindow;

	this.isPrassoViewLoaded = true;
	if(this.prassoView){    	
		this.isAjaxSubmitTriggered = false;
		this.prassoView.postMessage({name:"setDisplayText",params:[this.displayTextObj]}, this.iframeContentDomain);
		if(this.state.testMode == 1){	
				//this.prassoView.enableTestMode();
				this.prassoView.postMessage({name:"enableTestMode"}, this.iframeContentDomain);
			}
		}


		if(this.state.testMode == 1){
			this.getQuestion();	
		}
		else{
			//console.log("tot ques ",this.currentQuestionNo,this.totalNoQuestions);
			if (this.currentQuestionNo > this.totalNoQuestions) {
				this.setState({testCompleted:true});
				this.completeTest(true);
			} else {
				this.getQuestion();	  
			}
		}
	}
	componentDidMount(){		
		this.questionAnswerStartTime = null;
		this.questionAnswerElapsedTime = null;
		this.enableQuestionTrackTimer = false;
		clearInterval(this.intervalId);
		this.initiateQuestionPulseTimer();
		this.currentRating = null;
		this.props.onRef(this);
	   //console.log(this.props.topicInfoObj);
	   this.currentAttempt = (this.props.topicInfoObj.testMode==1) ? 1 : this.props.topicInfoObj.currentAttempt;
	   this.currentQuestionNo=(!isNaN(this.props.topicInfoObj.currentQNo) && this.props.topicInfoObj.currentQNo > 0 && (this.props.topicInfoObj.currentQNo <= this.props.topicInfoObj.questionCount)) ? (this.props.topicInfoObj.currentQNo) : 1;
	   ///this.currentQuestionNo = (this.props.topicInfoObj.testMode==1) ? 1 : this.props.topicInfoObj.currentQNo;
	   this.completedQuestionCnt = this.props.topicInfoObj.completedQnCount || 0;
	   this.seenQnCount = this.props.topicInfoObj.seenQnCount || 0;
	   this.totalNoQuestions = this.props.topicInfoObj.questions.length || 0;
	   

	   this.currentQuestionId = this.props.topicInfoObj.currentQuestionId || 0;

	   this.attemptsLeft = -1;
	   
	   if(this.state.attemptedQuestions){
	   	this.submittedQnMap = this.state.attemptedQuestions;
	   }
	   this.iframeContentDomain = this.getBasePath();
	   
	   window.addEventListener('message', this.handleMessage, false);
	   
	   if(!this.container){
	   	this.container = document.getElementById("quesIframe");
	   }

	   let iframeDOMNode = ReactDOM.findDOMNode(this.container);
	   
	   iframeDOMNode.addEventListener('load', this.iframeLoaded);
	   
	// const me = this;
	// 	setTimeout(() => {
	// 		me.markAttemptedQuestions();
	// 	}, 2000);  	

	   HmEventRegistry.fireEvent("INITIATE_GA_EVENT");  
	}
	compoenentWillMount(){
		this.props.onRef(undefined);
		window.removeEventListener('message', this.handleMessage, false);
	}
	initiateQuestionPulseTimer(){
		var me = this;
		this.intervalId = setInterval(() => {
			if(me.enableQuestionTrackTimer){	   	 		
				me.trackQuestionPulsed();
			}
		}, 30000);
	}
	trackQuestionPulsed(){
		try{
			var trackObj = {
				"test_id": this.props.topicInfoObj.testId,
				"snippet_id": this.currentSnippetId,
				"question_source":this.state.questionObj.questionSource,
				"attempt_no": this.attemptBeforeEvaluate
			}
			//this.initiateTrack("question_pulsed",trackObj);
		}catch(e){
		}
	}
	handleMessage(event){	
	//	console.log(event.origin+", "+this.iframeContentDomain);
	  /*if (event.origin !== this.iframeContentDomain) {
	    console.warn('Invalid origin:', event.origin);
	    return;
	}*/

	switch (event.data.name) {
		case 'renderingCompleted':
		this.setState({questionRendered:true,paginationDisabled:false});

		var endTime = new Date().getTime();
		var questionloadedTime = -1;
		if(this.questionLoadTime != null){
			questionloadedTime = endTime - this.questionLoadTime;
		}

		var trackingdummyObj = {};
		if(this.trackingQuestionObj !== undefined && typeof this.trackingQuestionObj === "object"){
			for(var key in this.trackingQuestionObj){
				trackingdummyObj[key] = this.trackingQuestionObj[key];
			}
		}

		trackingdummyObj["load_duration"] = questionloadedTime;		

		//this.initiateTrack("question_loaded",trackingdummyObj);
		this.questionLoadTime = null;
		questionloadedTime = null;


		if(this.questionAnswerStartTime == null){
			this.questionAnswerStartTime = new Date().getTime();
		}

		this.enableQuestionTrackTimer = true;	    	

		if(typeof this.props.resumeTimer === "function"){
			this.props.resumeTimer();
		}
		this.canMoveToNextQuestion = true;

		break;
		case 'userAnswer':
		this.handleUserAnswer(JSON.parse(event.data.params));
		break;
	    case 'pushedUserAnswer':  // enterkey event    	
	    if(this.state.testMode == 1){
	    		//if($("#evaluateBtn").hasClass("disabled")===false){	    			
	    			this.evalAndNavigate = false;
	    			this.evalAndSubmit = false;
	    			this.timeSpentAction = "Check";
	    			this.handleUserAnswer(JSON.parse(event.data.params));
	    		//}
	    	}else{
	    		if(this.state.questionEvaluated == false && this.isEvaluationGoing == false){	    			
	    			this.evalAndNavigate = false;
	    			this.evalAndSubmit = false;
	    			this.timeSpentAction = "Check";
	    			this.isEvaluationGoing = true;
	    			this.handleUserAnswer(JSON.parse(event.data.params));
	    		}
	    	}  
	    	break;
	    }
	}
	handleUserAnswer(userAnswer) {		 
		var me = this;
		var userAnswered = userAnswer.userAnswered;
		var userResponse =  userAnswer.userResponse;
		
		var topicInfoObj = this.props.topicInfoObj.questions[this.state.currentQuesNo-1];
		var testid = this.props.topicInfoObj.testId;
		var quesType = this.state.questionObj.questionType;
		var currrentAttempt = this.state.currentAttempt;
		var mcqRes = null;
		var fibRes = null;
		
		if(quesType === "mcq"){
			mcqRes = userResponse;
		}else{
			fibRes = userResponse;
		}
		
		me.setState({paginationDisabled:false});
		
		if(userAnswered === false){		
			if(me.state.testMode == 1){			
				
				if(this.evalAndSubmit){
					this.isEvaluationGoing = false;
					//me.trackTimeSpentInQuestion();
					me.completeTest();
					return;
				}
				
				if(userAnswer.partialAnswer){						
					this.isSubmitTriggered = false;
					this.evalAndNavigate = false;
					this.evalAndSubmit = false;
					this.isEvaluationGoing = false;
					return;
				}
				
			}else if(me.state.testMode == 2 && this.evalAndSubmit){
				//me.trackTimeSpentInQuestion();
				this.isEvaluationGoing = false;
				me.completeTest();
				return;
			}
		}
		
		if(userAnswered === false  && me.state.testMode != 1){
			me.prassoView.focus();
			this.isEvaluationGoing = false;
			return;
		}else{
			if(me.state.testMode != 1){
				if(me.state.questionObj.questionType == "mcq"){				
					if (!userResponse.isUserOptionCorrect) {
						me.chooseShowSolution(false,false,this.solutionResults);
						me.ShowHideSolution();
					}
					else{										
						me.chooseShowSolution(false,false,this.solutionResults);
						me.ShowHideSolution();
					}
				}
			}
		}

		const tempCurrentQues = me.getCurrentQuestionNo();
		//console.log(userAnswered,userResponse);
		var callBackSuccess = function(response){

			if(typeof me.props.resumeTimer === "function"){
				me.props.resumeTimer();
			}

			var data = response;
			var finalResult = true;
			me.isEvaluationGoing = false;
			me.canMoveToNextQuestion = true;
			var solutionResults = new Object();
			if(response!==null && response.data){

				if(response.data.answer && me.allQuestions && me.allQuestions.length > 1 ){
					//console.log("me.currentQuestionNo ",me.currentQuestionNo+" ",response.data.answer);
					let questions = me.allQuestions;
					let currQuesNo = me.currentQuestionNo;

					if(currQuesNo > 0){
						currQuesNo = (currQuesNo > 0) ? (currQuesNo-1) : 0
					}else{
						currQuesNo = (currQuesNo < 0) ? 0 : (currQuesNo-1);
					}

					me.allQuestions[currQuesNo].answer = response.data.answer;
				}				

				me.completedQuestionCnt = response.data.completedQnCount;
				me.seenQnCount = response.data.seenQnCount;
				me.setState({currentAttempt:response.data.currentAttempt});
				//,currentQuesNo:response.currentQNo
			}
			for(var res in data){
				finalResult = finalResult & data[res];
				solutionResults[res] = data[res];
			}
			
			if(me.state.questionObj.questionType == "fib"){	
				me.showSolution = false;
				me.correctAns = false;	
				me.setState({showSolution:false});
				me.chooseShowSolution(me.correctAns,me.showSolution,solutionResults);
				if(me.showSolution){
					if(me.state.testMode != 1){
						me.setScrollElement("answers-display");
					}
				}				
			}
			
			try{
				var trackingdummyObj = {};
				if(me.trackingQuestionObj !== undefined && typeof me.trackingQuestionObj === "object"){
					for(var key in me.trackingQuestionObj){
						trackingdummyObj[key] = me.trackingQuestionObj[key];
					}
				}

				trackingdummyObj["result"] = finalResult;
				trackingdummyObj["answered"] = (userAnswered === undefined) ? true : userAnswered;
				//me.initiateTrack("question_evaluated",trackingdummyObj);
			}catch(e){}

			
			me.setTmpQuestionNo(me.getCurrentQuestionNo());
			
			// let attempted = (response.data && response.data.attempted) ? response.data.attempted : false;
			// if(!me.attemptedQuestionIndices.has(tempCurrentQues) && attempted){
			// 	me.attemptedQuestionIndices.add(tempCurrentQues);
			// }else if(me.attemptedQuestionIndices.has(tempCurrentQues) && !attempted){
			// 	me.attemptedQuestionIndices.delete(tempCurrentQues);
			// }
			
			//console.warn("lalala::",me.attemptedQuestionIndices," : ",tempCurrentQues," , ",response.data);
			
			me.postEvaluation(finalResult, userAnswered);
			if(typeof me.temporaryCallBack === "function"){
				me.temporaryCallBack.apply(this);
			}
		}
		var callBackFailure = function(response){		
			if(typeof me.props.resumeTimer === "function"){
				me.props.resumeTimer();
			}

			me.canMoveToNextQuestion = true;
			me.isEvaluationGoing = false;
			console.log("QUESTION_EVALUATE Error : ", response);

			if(typeof me.temporaryCallBack === "function"){
				me.temporaryCallBack.apply(this);
			}
		}
		let contestId = this.props.topicInfoObj.contestId || 0;
		let roundTestId = this.props.topicInfoObj.roundTestId || 0;
		let userTestId = this.props.topicInfoObj.userTestId || 0;
		let testQuestionId = this.currentQuestionId || 0;
		let attemptNumber = this.state.currentAttempt || 0;
		let questionType  = quesType || '';
		let nextQuestionNo = (this.nextQuestionNo >= this.questionStart && this.nextQuestionNo <= this.totalNoQuestions) ? this.nextQuestionNo : this.totalNoQuestions;
			var userTestQnId = this.props.topicInfoObj.questions[nextQuestionNo-1].userTestQnId;
		

		let postParams = {
			"contestId":contestId,
			"roundTestId":roundTestId,
			"userTestId":userTestId,
			"testQuestionId":testQuestionId,
			"attemptNumber":attemptNumber,
			"fibUserResponse":fibRes,
			"mcqUserResponse":mcqRes,
			"questionType":questionType,
			"nextAttempt": {
				"userQuestionId" : userTestQnId,
				"attemptNumber" : 1
			}
		}		
		
		if(typeof me.props.callbackParent === "function"){
			postParams["time"] = window.btoa(me.props.callbackParent());
			console.log("QUESTION_EVALUATE ",me.props.callbackParent());
		}

		new HmAjax(this.getUrlFor("CONTEST_QUESTION_EVALUATE"),postParams).mask("ThreeDots").post(callBackSuccess,callBackFailure);

		this.canMoveToNextQuestion = false;
		if(typeof this.props.pauseTimer === "function"){
			this.props.pauseTimer();
		}		
	}
	postEvaluation(finalResult, userAnswered){
		var me = this;
		var topicInfoObj = this.props.topicInfoObj.questions[this.state.currentQuesNo-1];
		var currrentAttempt = this.state.currentAttempt;	
		
		me.setState({questionEvaluated:true});
		if(me.state.testMode == 1){	
			let questions = me.props.topicInfoObj.questions;

			if(me.state.pageCurrent>0){
				this.currentQuestionNo = (me.state.pageCurrent > questions.length) ? questions.length : me.state.pageCurrent;
			}else{
				this.currentQuestionNo = (me.state.pageCurrent < 0) ? 0 : me.state.pageCurrent;
			}

			me.currentQuestionId = me.props.topicInfoObj.questions[me.currentQuestionNo-1].questionId; 	
			
			me.setState({currentQuesNo:me.currentQuestionNo});

			if(userAnswered == false || userAnswered == "" ){
				delete this.submittedQnMap[topicInfoObj.id+"-"+currrentAttempt];
				me.setState({attemptedQuestions:this.submittedQnMap});	
				
			}else{
				this.submittedQnMap[topicInfoObj.id+"-"+currrentAttempt]=true;
				me.setState({attemptedQuestions:this.submittedQnMap});					
			}
			
			if(me.forceSubmit){
				this.evalAndSubmit = true;
				me.completeTest();
			}else if(this.isSubmitTriggered){
				me.showSubmitConfirm();
				this.isSubmitTriggered = false;			
			}else{
				if(this.evalAndNavigate){
					me.getQuestion();
				}
				else if(this.evalAndSubmit){
					me.completeTest();
				}
			}
			
			
		}else{
			
			if(finalResult == true){
				this.attemptsLeft = -1;
				this.currentAttempt = 1;
				this.currentQuestionNo++;
				this.completedQuestionCnt++;	
			}else{
				if (this.allowedAttempts < 1) {						
					this.currentAttempt++;
				} else {				
					this.attemptsLeft--;
					this.currentAttempt++;
					if (this.attemptsLeft > 0) {
						//$("#attemptsLeft").html(attemptsLeft.toString());
					} else if (this.attemptsLeft < 0) {
						this.attemptsLeft = -1;
						this.currentAttempt = 1;
						this.currentQuestionNo++;
					} else {
						//$("#attemptsLeft").html("-");
						this.attemptsLeft = -1;
						this.currentAttempt = 1;
						this.currentQuestionNo++;
					}
				}	
			}
			me.setState({currentAttempt:this.currentAttempt});
			console.log(this.currentQuestionNo,this.attemptsLeft,this.currentAttempt);
			if (this.currentQuestionNo > this.totalNoQuestions) {		
				me.setState({testCompleted:true});
				me.updateProgress();
				if(this.isAutoSubmitAllowed()){
					me.completeTest();
				}				
				return;
			}
		}		
		me.updateProgress();
	}
	chooseShowSolution(correctAns,showsolution,resultsObj){
		var me = this;
		if(me.state.testMode != 1){
			
			if(me.state.questionObj.questionType == "fib"){
				//this.prassoView.showSolution(false,showsolution,resultsObj);
				me.prassoView.postMessage({name:"showSolution",params:[false,showsolution,resultsObj]}, this.iframeContentDomain);
			}else{
				//this.prassoView.showSolution(false,showsolution);
				me.prassoView.postMessage({name:"showSolution",params:[false,showsolution]}, this.iframeContentDomain);
			}
			
			me.ShowHideSolution();
		}
	}
	ShowHideSolution(){
		
		if(this.showSolution){
			//$("#displaySolnStudent").html(btn_hidesolution);
		}else{
			//$("#displaySolnStudent").html(btn_viewsolution);
		}
	}
	setScrollElement(target){
		var me=this;
		setTimeout(function(){
			//this.prassoView.scrollToId(target);
			me.prassoView.postMessage({name:"scrollToId",params:[target]}, this.iframeContentDomain);
		}, 500);
	}
	modalCloseEvent(callBack=null){
		const me = this;

		const callBackSelf = () => {
			try{
				window.removeEventListener('message', me.handleMessage, false);
			}catch(e){}
			
			try{
				me.enableQuestionTrackTimer = false;
				clearInterval(me.intervalId);
			}catch(e){
				console.error("error while trying to close the timer", e);
			}

			try{
				
				me.timeSpentAction = "Close";
				if(me.isVisible($(".quesDispContainer"))==true){
				//	this.trackTimeSpentInQuestion();
				}
			}catch(e){
				console.error("Error::", e);
			}
			
			//this.trackTestClose();
			if(typeof callBack === "function"){
				callBack.apply(this);
			}
		}

		this.temporaryCallBack = callBackSelf;

		this.SaveClick();
	}
	trackTestClose(){
		var me = this;
		try{
			var postParams = {
				"trackingDefId" : 4,
				"testId" : this.props.topicInfoObj.testId,
				"endTime" : new Date().getTime()				
			}
			
			
			var callBackSuccess = function(response){
			}

			var callBackFailure = function(error){
				console.log("Error in TRACK_TEST_CLOSED");
			}

			new HmAjax(this.getUrlFor("TRACK_TEST_CLOSED"),postParams).post(callBackSuccess,callBackFailure);
		}catch(e){}
		
	}
	isVisible(element) {
		var element = $(element);
		if (element.length > 0 && element.css('visibility') !== 'hidden' && element.css('display') !== 'none') {
			return true;
		} else {
			return false;
		}
	}
	trackTimeSpentInQuestion(){
		if(this.questionAnswerStartTime == null){
			return;
		}

		try{
			var endTime = new Date().getTime();
			this.questionAnswerElapsedTime = (endTime - this.questionAnswerStartTime);
			var postParams = {
				"trackingDefId" : 3,
				"testId" :  this.props.topicInfoObj.testId,
				"questionId" : this.currTestQuestionId,
				"snippetId" : this.currentSnippetId,
				"currQuestAtt" : this.state.currentAttempt,
				"sourceId" : this.state.questionObj.questionSource,
				"timeSpent" : this.questionAnswerElapsedTime,
				"startTime" : this.questionAnswerStartTime,
				"endTime" : endTime,
				"action" : this.timeSpentAction
			}
			
			var me = this;
			var callBackSuccess = function(response){
			}

			var callBackFailure = function(error){
				console.log("Error in TRACK_QUESTION_TIMESPENT");
			}

			new HmAjax(this.getUrlFor("TRACK_QUESTION_TIMESPENT"),postParams).post(callBackSuccess,callBackFailure);
			
			this.questionAnswerStartTime = new Date().getTime();
			this.enableQuestionTrackTimer = false;
		}
		catch(e){}
	}

	getQuestion(){
	   this.allQuestions = (this.props.topicInfoObj && this.props.topicInfoObj.questions && this.props.topicInfoObj.questions.length>0) ? this.props.topicInfoObj.questions : [];
	   this.isEvaluationGoing = false;
	   this.setState({paginationDisabled:true,questionRendered:false,questionEvaluated:false,currentAttempt:this.currentAttempt,currentQuesNo:this.currentQuestionNo,showSolution:false});
	   var me = this;
	   this.questionAnswerStartTime = null;
	   this.enableQuestionTrackTimer = false;
	   this.currentRating = null;
	   var topicQuesObj = this.props.topicInfoObj.questions[this.currentQuestionNo-1];
	   var testid = this.props.topicInfoObj.testId;
	   let getQuestionURL = "";
	   this.allowedAttempts = topicQuesObj.maxAttempts;
	   this.currTestQuestionId  = topicQuesObj.questionId;
	   this.currentSnippetId = topicQuesObj.snippetId;

		if (this.allowedAttempts > 0) {
			
			if (this.attemptsLeft == -1) {
				this.attemptsLeft = this.allowedAttempts - (this.currentAttempt - 1);
			}
		} 
		
		this.attemptBeforeEvaluate = this.state.currentAttempt;
		
		
		var callBackSuccess = function(response){	

			let dataJsonList = response.data;
			let dataQuestion = dataJsonList;		
			//if(me.state.testMode == 1){
				dataQuestion = dataQuestion.questionContainer;
			//}
			me.setState({questionObj:dataQuestion});
			//console.log(dataJsonList.answer);
			me.prassoView.postMessage({name:"loadQuestion",params:[dataQuestion.question, dataJsonList.answer]}, me.iframeContentDomain);
			
			me.container.scrollTop = 0;
			me.updateProgress();
			me.checkImageLoaded();
		}

		var callBackFailure = function(response){
			this.questionLoadTime = null;
			me.setState({paginationDisabled:false});
			console.log("GET_QUESTION Error : ", response);
		}
		
		let contestId = this.props.topicInfoObj.contestId || 0;
		let roundTestId = this.props.topicInfoObj.roundTestId || 0;
		let userTestId = this.props.topicInfoObj.userTestId || 0;
		let testQuestionId = this.currentQuestionId || 0;
		let attemptNumber = this.state.currentAttempt || 0;


		if(this.allQuestions && this.allQuestions.length > 1 && this.allQuestions[1].questionContainer){
			callBackSuccess.apply(this, [{"data":me.allQuestions[(me.currentQuestionNo > 0) ? me.currentQuestionNo-1 : 0]}]);
		}else{
			new HmAjax(this.getUrlFor("CONTEST_GET_QUESTION")+"?contestId="+contestId+"&roundTestId="+roundTestId+"&userTestId="+userTestId+"&testQuestionId="+testQuestionId+"&attemptNumber="+attemptNumber).get(callBackSuccess,callBackFailure);
		}
		
		
		if(this.questionLoadTime == null){
			this.questionLoadTime = new Date().getTime();
		}
		this.trackingQuestionObj = {
			"test_id": testid,
			"snippet_id": this.currentSnippetId,
			"question_source":topicQuesObj.source,
			"attempt_no": this.state.currentAttempt
		}
	}
	submitClick(forceSubmit){
		this.forceSubmit = (forceSubmit === true) ? true : false;
		var me = this;
		this.isSubmitTriggered = true;
		this.timeSpentAction = "Submit";
		var unattemptedQuestionCount = this.state.totalQuestions - this.completedQuestionCnt; //this.state.totalQuestions - Object.keys(this.submittedQnMap).length;
		//console.log("unattemptedQuestionCount="+unattemptedQuestionCount);
	   /*if(unattemptedQuestionCount > 0){
			this.triggerGetUserAnswer(); 	
		}else{
			this.showSubmitConfirm();
		}	*/
		this.triggerGetUserAnswer(); 	
	}
	submitPractice(){
		this.isSubmitTriggered = false;
		this.evalAndNavigate = false;
		this.evalAndSubmit = true;

		this.completeTest();

		return;
		/**
		*IMPORTANT: Following block may have been written for a purpose which is unknown for the present devs.
		* Hence, commenting the code below. Should there be any unwanted scenarios, please check before uncommenting the following code.
		*/
	/**	var testId = this.props.topicInfoObj.testId;
		let testType = this.props.topicInfoObj.testType;

		var trackObj = {
			"test_id": testId,
			"submitted": true
		}		
		this.storeTrackEvent("test_closed", trackObj);

		this.timeSpentAction = "Submit";
		this.trackTimeSpentInQuestion();
		this.trackTestClose();

		let redirectUrl = "/scorecard/"+testId;
		if(testType === 5 || testType === 6){
			//window.location.href="/800";
			redirectUrl = "/report";
		}

		setTimeout(function(){
			window.location.href = redirectUrl;
		},500)
	*/
	}
	triggerGetUserAnswer(){
		this.evalAndNavigate = false;
		this.evalAndSubmit = false;
		this.evalAns();
	}
	showSubmitConfirm(){
		var me = this;
		var unattemptedQuestionCount = this.state.totalQuestions - this.completedQuestionCnt;//Object.keys(this.submittedQnMap).length;
		var msg = "";
		if(typeof me.props.resumeTimer === "function"){
			me.props.resumeTimer();
		}
		this.canMoveToNextQuestion = true;
		if(unattemptedQuestionCount > 0){
		   //msg = 'You have not attempted '+unattemptedQuestionCount+' question(s).';
		   msg = this.rb("test.confirm.unattempted",[unattemptedQuestionCount]);
		}else{
			msg = this.rb("test.confirm.allanswered");
		}
		confirmAlert({
			title: this.rb("test.confirm.wanttosubmit"),
			message: msg,
			buttons: [
				{
					label: this.rb("alert.no"),
					onClick: () => {
						this.isSubmitTriggered = false;
		
		
					}
				},
					{
						label: this.rb("alert.ok"),
						onClick: () => {
							this.isSubmitTriggered = false;
							this.evalAndNavigate = false;
							this.evalAndSubmit = true;
						//me.evalAns();
						me.completeTest();
					}
				}	
		]
	});	  
	}
	showAutoSubmitConfirm(callback, response){
		var me = this;
		var unattemptedQuestionCount = this.state.totalQuestions - this.completedQuestionCnt; //this.state.totalQuestions - Object.keys(this.submittedQnMap).length;
		var msg = "";
		if(unattemptedQuestionCount > 0){
			//msg = 'You have not attempted '+unattemptedQuestionCount+' question(s).';
			msg = this.rb("test.confirm.unattempted",[unattemptedQuestionCount]);
		}else{
			msg = this.rb("test.confirm.allanswered");
		}
		confirmAlert({
			title: this.rb("test.confirm.autosubmit"),
			message: msg,
			buttons: [
			{
				label: this.rb("alert.autosubmit.ok"),
				onClick: () => {
					if(typeof callback === "function"){
						callback.apply(this,[response]);
					}
			/* 	this.isSubmitTriggered = false;
				this.evalAndNavigate = false;
				this.evalAndSubmit = true;
				//me.evalAns();
				me.completeTest(); */ //not commented
			}
		}
		],
		closeOnClickOutside : false
	});	  
	}
	completeTest(isScoreCard=false){	  
		var me = this;

		var testId = me.props.topicInfoObj.testId;
		var testType = me.props.topicInfoObj.testType;
		var contestHost = me.getContestHost();

		let finalCallBack = function(response){
			me.prassoView.postMessage({name:"disableInput"}, me.iframeContentDomain);


			let redirectUrlByType = (window.cont_test_type_submit_route) ? window.cont_test_type_submit_route[contestHost] : null;

			if(redirectUrlByType){
				window.location.href=redirectUrlByType;
			}else if(me.state.testMode == 1 || isScoreCard || !redirectUrlByType){
				//console.log("testId22="+testId)
				var trackObj = {
					"test_id": testId,
					"submitted":true
				}
				me.storeTrackEvent("test_closed", trackObj);
				//me.trackTestClose(); 

				window.location.href="/scorecard/"+testId;

			}
			if(typeof me.props.closeTimer === "function"){
				me.props.closeTimer();
			}
		}

		var callBackSuccess = function(response){	
			if(me.forceSubmit){
				me.showAutoSubmitConfirm(finalCallBack, response);
			}else{
				finalCallBack(response); 
			}			
		}

		var callBackFailure = function(response){	
			me.isAjaxSubmitTriggered = false;
			console.log("SUBMIT_TEST Error : ", response);
			//me.setState({  modalContent:me.setTestScreen() });
		}		
		
		var postParams={			
			"contestId":this.props.topicInfoObj.contestId,
			"roundTestId":this.props.topicInfoObj.roundTestId,
			"userTestId":this.props.topicInfoObj.userTestId
		}

		if(typeof me.props.callbackParent === "function"){
			postParams["time"] = window.btoa(me.props.callbackParent());
			//console.log("submit test ",this.props.callbackParent());
		}

		if(!this.isAjaxSubmitTriggered){
			this.isAjaxSubmitTriggered = true;
			new HmAjax(this.getUrlFor("CONTEST_SUBMIT_TEST"),postParams).post(callBackSuccess,callBackFailure);
		}	
		
		// var postParams={			
		// 	"testId":testId,
		// 	"revisionTestId":this.props.revisiontestid,
		// 	"topicSubtopicMapId":this.props.topicsubtopicId
		// }

		// if(typeof me.props.callbackParent === "function"){
		// 	postParams["time"] = window.btoa(me.props.callbackParent());
		// 	//console.log("submit test ",this.props.callbackParent());
		// }

		// if(!this.isAjaxSubmitTriggered){
		// 	this.isAjaxSubmitTriggered = true;
		// 	new HmAjax(this.getUrlFor("SUBMIT_TEST"),postParams).put(callBackSuccess,callBackFailure);
		// }		
		
	}
	updateProgress() {	
		var percentComplete = 0 ;
		if(this.state.testMode == 1){
			percentComplete = Math.round((this.completedQuestionCnt / this.state.totalQuestions) * 100); //Math.round(((Object.keys(this.submittedQnMap).length) / this.state.totalQuestions) * 100);
		}else{
			percentComplete = Math.round(((this.currentQuestionNo-1) / this.totalNoQuestions) * 100); //Math.round(((this.currentQuestionNo-1) / this.totalNoQuestions) * 100);
		}
		
		this.setState({percentageComplete:percentComplete});		
	}
	EvaluateClick(){
		if(this.isEvaluationGoing == false){
			this.evalAndNavigate = false;
			this.evalAndSubmit = false;	
			this.isEvaluationGoing = true;
			this.timeSpentAction = "Check";
			this.evalAns();
		}
	}
	SaveClick(){
		if(this.isEvaluationGoing == false){
			let currClickQues = this.getCurrentQuestionNo();
			this.nextQuestionNo = currClickQues;

			this.evalAndNavigate = false;
			this.evalAndSubmit = false;	
			this.isEvaluationGoing = true;
			this.timeSpentAction = "Save";
			this.evalAns();
		}
	}
	PrevClick(){
		if(this.canMoveToNextQuestion){
			this.prevchangeEvent();	
		}else{
			console.warn("cannot move to previous question until current one is rendered.");
		}		
	}
	NextClick(){
		// this.getQuestion();
		// this.timeSpentAction = "Next";
		// var unattemptedQuestionCount = this.state.totalQuestions - this.completedQuestionCnt; //this.state.totalQuestions - Object.keys(this.submittedQnMap).length;
		// console.log("unattemptedQuestionCount="+unattemptedQuestionCount);
		// this.triggerGetUserAnswer(); 
		if(this.canMoveToNextQuestion){	
			this.changeEvent();
		}else{
			console.warn("cannot move to next question until current one is rendered.");
		}
	}
	viewHideSolutionClick(){
		this.showSolution = !this.showSolution;		
		this.chooseShowSolution(this.correctAns,this.showSolution,this.solutionResults);
		this.setState({showSolution:this.showSolution});
		if(this.showSolution){
			this.setScrollElement("solution-display");
		}else{
			this.setScrollElement("question-display");			
		}
		
		this.trackShowHideSolution(this.showSolution);
		this.checkImageLoaded();
	}
	trackShowHideSolution(showSol){
		var myaction = "";

		if(showSol == true){
			myaction = "Open";
		}else{
			myaction = "Close";			
		}
		var postParams = {
			trackingDefId: 1,
			testId : this.props.topicInfoObj.testId,
			questionId : this.currTestQuestionId,
			snippetId : this.currentSnippetId,			
			currQuestAtt : this.state.currentAttempt,
			sourceId : this.state.questionObj.questionSource,
			action : myaction
		}
		
		var me = this;
		var callBackSuccess = function(response){
			
		}

		var callBackFailure = function(error){
			console.log("Error in TRACK_SOLUTION");
		}

		new HmAjax(this.getUrlFor("TRACK_SOLUTION"),postParams).post(callBackSuccess,callBackFailure);
		
		try{
			var trackObj = {
				"test_id": this.props.topicInfoObj.testId,
				"snippet_id": this.currentSnippetId,
				"question_source":this.state.questionObj.questionSource,
				"item_type": this.getTracker().enums.viewedItemType.solution,
				"hidden": !showSol
			}
			//this.initiateTrack("item_viewed",trackObj);
		}catch(e){
		}
	}
	getStatusText(){
		if(this.props.topicInfoObj.status == "IN_PROGRESS"){
			return this.rb("home.continue");
		}else{
			return "Start Practice";
		}
	}
	getStatusActionText(){	  


		if(this.props.subtopic){
			if(this.props.subtopic.status == "IN_PROGRESS"){
				if(this.props.subtopic.testStatus == "COMPLETED" && this.props.subtopic.reqTestStatus != "COMPLETED"){
					if(this.props.subtopic.reqTestStatus == "IN_PROGRESS"){
						return this.rb("home.resume");	
					}else{
						return this.rb("home.start");
					}
				}

				return this.rb("home.resume");			
			}else if(this.props.subtopic.status == "COMPLETED"){
				return "";
				
			}else{
				return this.rb("home.start");
			}
		}else if(this.props.studentStatus){
			if (this.props.studentStatus === "IN_PROGRESS") {
				return this.rb("home.resume");
			} else {
				return this.rb("home.start");
			}
		}
	}
	getviewhideText(){
		if(this.state.showSolution){
			return this.rb("test.hidesolution");
		}else{
			return this.rb("test.viewsolution");
		}
	}

	getPagination = () => {
		if(this.state.pageTotal>1){
			let siblingPagesRange =  (this.isTab() || this.isMobile()) ? 1 : 3;
		return(
			<Fragment>
				{
					(() => {
						let disabledBtn = !this.state.questionRendered;
						if(this.currentQuestionNo <= this.questionStart){
							disabledBtn = true
						}
						return(
							<button type="button" className="btn btn-primary mediumBtn navgbtn prevbtn" disabled={disabledBtn} onClick={this.PrevClick}>
								<i className="material-icons">chevron_left</i> {this.rb("test.prev")}
							</button>
						)
					})()
				}
				<Pagination
					currentPage={this.state.currentQuesNo}
					totalPages={this.state.pageTotal}
					boundaryPagesRange={1}
					siblingPagesRange={siblingPagesRange}
					hidePreviousAndNextPageLinks={true}
					hideFirstAndLastPageLinks={true}
					hideEllipsis={false}
					onChange={this.onPageChange}
					disabled={this.state.paginationDisabled}
				/>

				{
					(() => {
						let disabledBtn = !this.state.questionRendered;
						if(this.currentQuestionNo >= this.totalNoQuestions){
							disabledBtn = true
						}
						return(
							<button type="button" className="btn btn-primary mediumBtn navgbtn nxtbtn" disabled={disabledBtn} onClick={this.NextClick}>
								{this.rb("test.next")} <i className="material-icons">chevron_right</i>
							</button>
						)
					})()
				}
			</Fragment>
		)
		}
	}

	renderBottomSection(){
		//console.log("this.props.topicInfoObj:::",this.props.topicInfoObj);
		
		return(
			<MuiThemeProvider>
			<div className="col-12 row nopadding">				

			{(() => {
				if(this.state.testMode == 1){		
					return(
						<div className="col-12 row nopadding contest_get_test">	

						<div className="flex-container">
								<div className="savedivbtn">
									<button type="button" className="btn btn-primary mediumBtn savebtn" data-ga="Student- test taking - save button" disabled={!this.state.questionRendered} onClick={this.SaveClick}>
									{this.rb("test.save")}
									</button>
								</div>
								<div className="paginationbtn">
									{this.getPagination()}
								</div>
								<div className="submitbtn">
									{
										(() => {
											let disabledBtn = !this.state.questionRendered;
											if(this.seenQnCount < this.totalNoQuestions){
												disabledBtn = true
											}
											disabledBtn = false
											return(
											<div className="submittestbtndiv">
												<button type="button" className="btn btn-primary mediumBtn subbutton" data-ga="Student- test taking - submit button" disabled={disabledBtn} onClick={this.submitClick}>
												{this.rb("test.submittest")}
												</button>
											</div>
											)
										})()
									}
								</div>
							</div>
						</div>
						)
				}else{
					if(this.state.questionEvaluated == false){
						return(
							<div className="col-12 row">	
							<div className="col-12 col-sm-12">											
							<button type="button" className="btn btn-primary mediumBtn float-right" disabled={!this.state.questionRendered && !this.isEvaluationGoing} onClick={this.EvaluateClick}>
							{this.rb("test.check")}
							</button>	
							</div>										 
							</div>
							)
						}else{
							return(
							<div className="col-12 row">	
							<div className="col-12 col-sm-12 nopadding">		
							{(() => {
								if(this.state.testCompleted){
									return(
									<button type="button" className="btn btn-primary mediumBtn float-right mb-20 ml-10" disabled={!this.state.questionRendered} onClick={this.submitPractice}>
									{this.rb("test.submit")}
									</button>	
									);
								} else{
									return(
									<button type="button" className="btn btn-primary mediumBtn float-right mb-20 ml-10" disabled={!this.state.questionRendered} onClick={this.NextClick}>
									{this.rb("test.next")}
									</button>	
									);
								}											 				
							})()}

							<button type="button" className="btn btn-primary mediumBtn float-right" disabled={!this.state.questionRendered} onClick={this.viewHideSolutionClick}>
							{(() => {
								if(this.state.showSolution){return (<div>{this.rb("test.hidesolution")}</div>)} else{return (<div>{this.rb("test.viewsolution")}</div>)}											 				
							})()}											 			
						</button>
						</div>										 
						</div>
						)
					}

				}
			})()}

			</div>
			</MuiThemeProvider>
			);
		}

		updateQuestionDisplay(){
			return(
				<div className="questionsDisp float-right">
				{(() => {
					if(this.state.testMode == 1){		
						return(
							<h5><span>Questions Attempted:&nbsp;</span> {this.completedQuestionCnt} <span>&nbsp;of&nbsp;</span> {this.props.topicInfoObj.questionCount} </h5>
						// <h5>{this.state.percentageComplete}% {this.rb("test.complete")} </h5>
						)
					}
					// else{						
					// 	return(
					// 	<h5>{this.state.percentageComplete}% {this.rb("test.complete")} &nbsp; | &nbsp;{this.rb("test.attemptsleft")}: {(this.attemptsLeft<0)?0:this.attemptsLeft} </h5>
					// 	)
					// }
				})()}
				</div>
				);
		}

		updatePercentageDisplay(){


			return(
			<div className="percentageDisp float-right">
			{(() => {
				if(this.state.testMode == 1){		
					return(
					<h5>{this.state.percentageComplete}% {this.rb("test.complete")} </h5>
					)
				}else{						
					return(
					<h5>{this.state.percentageComplete}% {this.rb("test.complete")} &nbsp; | &nbsp;{this.rb("test.attemptsleft")}: {(this.attemptsLeft<0)?0:this.attemptsLeft} </h5>
					)
				}
			})()}
			</div>
			);
		}
		likeFn(event){
			if($(event.currentTarget).hasClass("selected")){
				return false;
			}
			const ratingIcons = document.querySelectorAll('.ratingIcon');
			ratingIcons.forEach(rating => {
				rating.classList.remove('selected');
			})
			event.currentTarget.classList.add("selected");

			var postParams = {
				trackingDefId: 2,
				testId : this.props.topicInfoObj.testId,
				questionId : this.currTestQuestionId,
				snippetId : this.currentSnippetId,
				rating : parseInt($(event.currentTarget).attr("data-id")), 
				currQuestAtt : this.state.currentAttempt,
				sourceId : this.state.questionObj.questionSource,
				action : "submit"
			}
			this.currentRating = parseInt($(event.currentTarget).attr("data-id"));
			var me = this;
			var callBackSuccess = function(response){
				$(".likebox").attr("data-myrating",this.currentRating);
			}

			var callBackFailure = function(error){
				console.log("Error in TRACK_SOLUTION");
			}

			new HmAjax(this.getUrlFor("TRACK_SOLUTION"),postParams).post(callBackSuccess,callBackFailure);


			try{
				var trackObj = {
					"test_id": this.props.topicInfoObj.testId,
					"snippet_id": this.currentSnippetId,
					"question_source":this.state.questionObj.questionSource,
					"attempt_no": this.attemptBeforeEvaluate,
					"helpful": parseInt($(event.currentTarget).attr("data-id")) === 2,
					"source":this.getTracker().enums.itemRatedSource.test
				}
				//this.initiateTrack("solution_rated",trackObj);
			}catch(e){
			}


		}
		setRatingSelected(id){
			if(this.currentRating != null){
				if(this.currentRating == id){
					return "selected";
				}
			}
		}
		renderRatingContainer() {
			if(this.state.showSolution){
				return (
				<div className="likebox" data-myrating="0">
				<p>{this.rb("rating.title")}</p>
				<div className="btngp">
				<span className={"ratingIcon "+this.setRatingSelected(2)} data-id="2" onClick={this.likeFn.bind(this)}><i className="material-icons">thumb_up</i></span>
				<span className={"ratingIcon "+this.setRatingSelected(1)} data-id="1" onClick={this.likeFn.bind(this)}><i className="material-icons">thumb_down</i></span>
				</div>
				</div>
				)
			}
		}
		checkImageLoaded(){	
			try{
				$('img').unbind("error");
				$('img').error(function(){		
					var me = this;
					var timeDelay = 5000;

					if(!$(me).attr('imageReloadCount')){
						$(me).attr('imageReloadCount',1);
					}

					timeDelay = timeDelay * parseInt($(me).attr('imageReloadCount'));			

					setTimeout(function()
					{ 				
						if(!$(me).attr('imageReloadCount')){
							$(me).attr('imageReloadCount',1);
						}else{
							$(me).attr('imageReloadCount',parseInt($(me).attr('imageReloadCount'))+1);
						}

						if($(me).attr('imageReloadCount')<=4){
							//console.log("timeDelay::",timeDelay);
							$(me).attr('src',$(me).attr('src'));
						}

						if(console){
							console.log("image not loaded :"+$(me).attr('src'));			
						}

					}, timeDelay);		

				}).load(function(){
					//console.log("loaded successfully...");
				});
			}
			catch(e){

			}

		}
		render = () => {
			let me = this;
			return(				
			<div className="row modalBase testTakingScreen">

			<div className="col-12 quesDispContainer">
			<div className="clearfix">
			<div className="quesNumDisp float-left"><div> Question&nbsp;{this.state.currentQuesNo}</div></div>
			{this.updateQuestionDisplay()}
			{/* {this.updatePercentageDisplay()} */}
			{/* <div className="float-right"><CircularProgressbar percentage={ this.state.percentageComplete}  styles={{
				path: { stroke: 'rgba(62, 152, 199, ${this.state.percentageComplete / 100})' },
			}}/></div> */}
			</div>
			<Iframe url={this.getBasePath() + "/prassoapp/20171102/"}
			ref = {e => {
				me.container = e;
			}}
			position="relative"
			id="quesIframe"
			width="100%"				            
			className="quesIframe"
			onError={()=>{debugger;}}
			height="100%"				            
			styles={{height: "63vh"}}					
			allowFullScreen/>
			</div>


			{this.renderRatingContainer()}

			{this.renderBottomSection()}					
			</div>
			);
		}
	}

	export default ContestGetTest;


// WEBPACK FOOTER //
// ./src/views/contest/ContestGetTest.js